import $ from "jquery";

const getHeaderHeight = () => $(".js-header").innerHeight() || 0;

/** data-anchor-offset の値（例: 1.8rem, 24px）を縦方向の px に変換 */
const parseCssLengthToPx = (value) => {
  const trimmed = (value || "").trim();
  if (!trimmed) return 0;
  const probe = document.createElement("div");
  probe.style.cssText =
    "position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;height:0";
  probe.style.height = trimmed;
  document.body.appendChild(probe);
  const px = probe.offsetHeight;
  document.body.removeChild(probe);
  return px;
};

const getAnchorOffsetExtra = (el) => {
  if (!el?.getAttribute) return 0;
  return parseCssLengthToPx(el.getAttribute("data-anchor-offset"));
};

const scrollToHash = (hash) => {
  if (!hash || hash === "#") return;
  const $target = $(hash);
  if (!$target.length) return;
  const offset = $target.offset();
  if (!offset) return;
  const extra = getAnchorOffsetExtra($target[0]);
  const position = offset.top - getHeaderHeight() - extra;
  $("body,html").stop().animate({ scrollTop: position }, 500);
};

export const anchorScroll = () => {
  const urlHash = location.hash;

  if (urlHash && urlHash !== "#") {
    $("body,html").stop().scrollTop(0);
    setTimeout(function () {
      scrollToHash(urlHash);
    }, 500);
  }

  $('a[href^="#"]').on("click", function (e) {
    const href = $(this).attr("href");
    if (!href || href === "#") return;

    const $target = $(href);
    if (!$target.length) return;

    e.preventDefault();

    document.dispatchEvent(new Event("spmenu:close"));

    const hash = href;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToHash(hash);
      });
    });
  });
};
